import React, { useContext, useEffect } from 'react';
import GifPicker from 'gif-picker-react';
import { LanguageContext } from '../../../libs/Context';

const GifPickerWrapper = ({ handleEmoji }) =>
{
	const { language } = useContext(LanguageContext);

	useEffect(() =>
	{
		const searchInput = document.querySelector('.gpr-search');

		if (searchInput)
		{
			searchInput.setAttribute('placeholder', language?.search);
		}
	}, []);

	return (
		<GifPicker tenorApiKey={process.env.REACT_APP_GIF_KEY as string ?? 'AIzaSyBrxb-My7KzLfIjOBbpugRn-plcFdmOB0w'}
			width='var(--percent100)'
			height={320}
			onGifClick={(gif:any) => { handleEmoji(gif); }}
		/>
	);
};

export default GifPickerWrapper;